import React from 'react';
import * as h from '../../helpers/helpers';
import { lu } from '../../data/reportData';
import { TAB, H1, TXR_B, TXC_I1, CK1 } from "../../styles/urar-styles";
import { IMAGE_1, COMMENTARY, EXHIBITS, TABLE } from "../../styles/urar-styles";
import { ADDD } from './ADDD';
import { PROPERTY_UNIT } from './PropertyUnit';


export function OUTBUILDINGS() {
	//console.log("outbuildings: ", global.ptr.subOutbuildingList);
  var outbuildings = global.ptr.subOutbuildingList;
  if (outbuildings.length === 0) return;

	return (
		<>
			{
				outbuildings.map((out, oi) => {
					return (
						<React.Fragment key={oi}>
							<OUTBUILDING outbuilding={out} bldg={oi} />
							<PROPERTY_UNITS outbuilding={out} />
						</React.Fragment>
					)
				})
			}
		</>
	)
}

function PROPERTY_UNITS({outbuilding}) {

	if (outbuilding.propertyUnits.length === 0) return;
	var units = outbuilding.propertyUnits;

		return (
			<>
			{
				units.map((u, i) => {
					return ( <PROPERTY_UNIT key={i} unit={u} /> )
				})
			}
			</>
		)
	}


export function OUTBUILDING({outbuilding, bldg}) {
	//console.log("outbuilding: ", bldg, outbuilding);

	global.ptr.outbuilding = outbuilding;
	global.ptr.outbuildingDetail = outbuilding.improvementDetail;
	global.ptr.outbuildingDetail = outbuilding.improvementDetail;

	var impDetail = outbuilding.improvementDetail;
	var bHasAdu = outbuilding.HasADU();
	var bRealProperty = impDetail.outbuildingRealPropertyIndicator ?? false;
	var type = "(" + outbuilding.GetOutbuildingType() + ")";
	var title = "Outbuilding - " + type;

	return (
		<>
				<TAB title={title} />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Considered Real Property" value={lu("12.002")} />
						{ bRealProperty &&
						<TXR_B title="Units in Structure" value={lu("12.003")} />
						}
						<TXR_B title="Attached to Permanent Foundation" value={lu("12.004")} />
						{ bRealProperty &&
						<>
							<TXR_B title="Structure Volume" value={lu("12.005")} />
							<TXR_B title="Gross Building Area" value={lu("12.006")} />
							<TXC_I1 comment="Gross Building Area for the outbuilding includes area for vehicle storage, ADU(s), and any other uses" />
						</>
						}
					</div>
					<div>
						<IMAGE_1 category="OutbuildingExhibit" />
					</div>
				</div>

				{ bRealProperty &&
				<>
					<H1 title="Detail" />
					<div className='col2 mt-3'>
						<div>
							{ !bHasAdu && 
							<>
								<CK1 title="Heating" value={lu("12.008")} yn />
								<CK1 title="Cooling" value={lu("12.009")} />
							</>
							}
							<TXR_B title="Utilities" value={lu("12.010")} />
						</div>
						<div>
							<TXC_I1 comment="The table below depicts the area of the outbuilding, excluding vehicle storage and any ADU(s)" nospace />
							<TABLE titles={["Finish","Total Area","Room Summary"]} widths={[180,180,180]} values={lu("12.011-13")} />
						</div>
					</div>

					{ lu("12.003") > 0 &&
					<>
						<H1 title="Mechanical System Details" />
						<div className='col2 mt-3'>
							<div>
								<TABLE titles={["","System","Detail"]} widths={[180,180,180]} values={lu("12.014-16")} />
							</div>
							<div>
								<TXR_B title="Other Mechanical Systems" value={lu("12.017")} />
							</div>
						</div>
					</>
					}
					<ADDD values={lu("12.020-24")} subtitle={type} /> 
				</>
				}
				
				<COMMENTARY title="Outbuilding Commentary" value={lu("12.025")} />

				<EXHIBITS title="Outbuilding Exhibits" values={lu("12.099")} />
		</>
	)
}

